import React from 'react';
import { Box, Typography } from '@mui/material';

// Portal page title with the app's accent-rail treatment + optional subtitle
// and right-aligned action. Mirrors the PageHeader hierarchy used across the app.
export default function PortalPageHeader({ title, subtitle, action }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap', mb: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
                <Box sx={{ width: 4, height: 40, borderRadius: '3px', background: 'linear-gradient(180deg, #427898, #1e3a52)', flexShrink: 0 }} />
                <Box sx={{ minWidth: 0 }}>
                    <Typography sx={{ fontSize: 21, fontWeight: 800, color: '#0f2135', letterSpacing: '-0.01em', lineHeight: 1.2 }}>
                        {title}
                    </Typography>
                    {subtitle && (
                        <Typography sx={{ fontSize: 13, color: '#64748b', mt: 0.2 }}>
                            {subtitle}
                        </Typography>
                    )}
                </Box>
            </Box>
            {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
        </Box>
    );
}
